<template>
  <div>
    <CCardBody class="py-0 pl-2 pr-0">
      <table class="table mb-0">
        <tbody>
          <div
            class="custom-width-total"
            v-for="(r, index) in customUbicaciones.filter(
              ubi => ubi.payload.pertenece_id == ubicacionPadre
            )"
            :key="index"
          >
            <tr class="custom-width-total" 
              :class="
              `${
                customUbicaciones.filter(u => u.payload.pertenece_id == r.id)
                  .length > 0
                  ? `cursor-p`
                  : ``
              }`"
            >
              <td>
              </td>
                <input type="checkbox" v-model="r.selected" class="form-check-input mt-3" :id="'cb'+r.id" @change="buscarDatos(r,'cb'+r.id)">
              <td @click="toggleSubUbicaciones(index, r)" class="custom-width px-4">
                <span>
                  <CIcon
                    v-if="
                      customUbicaciones.filter(u => u.payload.pertenece_id == r.id)
                        .length > 0
                    "
                    name="cil-chevron-circle-down-alt"
                  />
                </span>
                {{ r.payload.nombre }}
              </td>
              <!-- <td
                @click="toggleSubUbicaciones(index, r)"
                class="custom-width px-4"
                :class="
                  `${
                    customUbicaciones.filter(u => u.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                {{
                  r.payload.cultivo_id == 0
                    ? ""
                    : getCultivo(r.payload.cultivo_id)
                }}
              </td> -->
              <td @click="toggleSubUbicaciones(index, r)" class="custom-width px-4">
              </td>
              <td @click="toggleSubUbicaciones(index, r)" class="custom-width5">
              </td>
            </tr>
            <tr
              v-if="
                customUbicaciones.filter(p => p.payload.pertenece_id == r.id).length >
                  0
              "
            >
              <td class="py-0 pl-2 pr-0" colspan="5">
                <CCollapse
                  :show="subDetails.includes(index)"
                  class="m-0 custom-width-total"
                >
                  <table-collapse
                    @click-cancel="toggleCancel"
                    @click-print="printNanoid"
                    :ubicacionPadre="r.id"
                    :cultivos="cultivos"
                    :ubicaciones="customUbicaciones"
                    :avisar="avisar"
                  ></table-collapse>
                </CCollapse>
              </td>
            </tr>
          </div>
        </tbody>
      </table>
    </CCardBody>
  </div>
</template>


<script>
import { mapState } from 'vuex';

export default {
  name: "TableCollapse",

  props: {
    ubicaciones: {
      type: Array
    },
    cultivos: {
      type: Array
    },
    defaultValue: {
      type: Array
    },
    ubicacionPadre: {
      type: Number
    },
    avisar: {
      type: Function,
      default: ()=>{}
    }
    // ubicacionesSelec: {
    //   type: Array,
    //   default: []
    // }
  },

  data() {
    return {
      subDetails: [],
      itemModal: { id: "", name: "", index: "" },
      ubicacionesSelec: [],
      customUbicaciones: [],
    };
  },

  components: {
    TableCollapse: () => import("./TableCollapse1.vue"),
  },
  computed: mapState(['enviado']),
  watch: {
    ubicaciones(newValue){
      this.customUbicaciones = newValue.map(r=>({...r,selected: !!this.defaultValue?.find(f=>f.value===r.id)||false}))
    },
    customUbicaciones(newV){
      this.ubicacionesSelec = newV.filter(ff=>ff.selected).map(m=>({value: m.id, label: m.payload.nombre, ruta: m.payload.ruta}))
      this.$emit('setValueCallback',this.ubicacionesSelec)
      this.$store.state.count = this.ubicacionesSelec
    },
    enviado(newValue){
      if (newValue == true) {
        this.$store.dispatch('updateStatus', false)
        this.details = []
        this.customUbicaciones.forEach(ubicacion => {
          ubicacion.selected = false
        });
        // console.log(this.$store.state.enviado)
        
      }
    }
    // '$store.state.count'(){
      //   if (this.$store.state.count.length == 0) {
      //     console.log(this.$store.state.count)
    //   }
    // }
  },
  created () {
    this.$emit('clearCallback',this.clearCallback)
    
  },

  methods: {
    clearCallback(){
      this.customUbicaciones = this.customUbicaciones.map(r=> ({...r, selected: false}))
    },
    buscarDatos(parametros,idcb) {
      this.ubicacionesSelec = this.$store.state.count
      let ids = parametros.payload.ruta.slice(1,-1).split('/')
      let exist = false

      for (let id = 0; id < ids.length; id++) {
        if (this.ubicacionesSelec.find( ubicacion => ubicacion.value == ids[id]) && ids[id] != ids[ids.length - 1]) {
          exist = true
          parametros.selected = false
          document.getElementById(idcb).checked = false;
        }
      }
      if (exist == false) {
        this.ubicacionesSelec.find( ubicacion => {
          let ubicacionesRuta = ubicacion.ruta.slice(1,-1).split('/')
          ubicacionesRuta.forEach(ubicacionRuta => {
            if (ubicacionRuta == parametros.id) {
              exist = true
              parametros.selected = false
              document.getElementById(idcb).checked = false;
            }
          });
        })
      }
      if (parametros.selected && exist == false) {
        if (!this.ubicacionesSelec.find( ubicacion => ubicacion.value == parametros.id )) {
          this.ubicacionesSelec.push({value: parametros.id, label: parametros.payload.nombre, ruta: parametros.payload.ruta})
        }
      }else{
        this.ubicacionesSelec = this.ubicacionesSelec.filter(ubicacion => ubicacion.value != parametros.id)
        this.$store.state.count = this.ubicacionesSelec
      }
      exist = false
      // console.log(this.$store.state.count)
      this.avisar(parametros)
      this.$emit('setValueCallback',this.ubicacionesSelec)
    },
    toggleCancel(index, item) {
      this.$emit("click-cancel", index, item);
    },
    printNanoid(ubicacion) {
      this.$emit("click-print", ubicacion);
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },

    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.find(
        cultivo => cultivo.id == cultivo_id
      );

      return cultivoActual ? cultivoActual.payload.nombre : "";
    },
    toggleSubUbicaciones(index) {
      const positionSub = this.subDetails.indexOf(index);
      positionSub !== -1
        ? this.subDetails.splice(positionSub, 1)
        : this.subDetails.push(index);
    }
  }
};
</script>

<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 50%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
